import { SliceCreator } from "@/features/vidyo-call/types/vidyo-common";

import { Participant } from "../types/participant";

export interface ParticipantsState {
  moderatorIds: string[];
  setModeratorIds: (moderatorIds: string[]) => void;
  participants: {
    participants: Participant[];
    add: (participant: Participant) => void;
    remove: (participantId: string) => void;
    updateParticipantsStatus: (participants: Participant[]) => void;
    toggleCurrentParticipantHand: () => void;
    isRaisedHandSoundEnabled: boolean;
    setIsRaisedHandSoundEnabled: (isRaisedHandSoundEnabled: boolean) => void;
  };
}

export const createParticipantsSlice: SliceCreator<keyof ParticipantsState> = (
  set,
) => ({
  moderatorIds: [],
  setModeratorIds: (moderatorIds: string[]) => {
    set({ moderatorIds }, undefined, "participants/setModeratorIds");
  },
  participants: {
    participants: [],
    isRaisedHandSoundEnabled: true,
    setIsRaisedHandSoundEnabled: (isRaisedHandSoundEnabled: boolean) => {
      set(
        (state) => {
          state.participants.isRaisedHandSoundEnabled =
            isRaisedHandSoundEnabled;
        },
        undefined,
        "participants/setIsRaisedHandSoundEnabled",
      );
    },
    add: (participant: Participant) => {
      set(
        (state) => {
          // Check if participant already exists before adding
          const exists = state.participants.participants.some(
            (p) => p.participantId === participant.participantId,
          );
          if (!exists) {
            state.participants.participants.push(participant);
          }
        },
        undefined,
        "participants/add",
      );
    },
    remove: (participantId: string) => {
      set(
        (state) => {
          state.participants.participants =
            state.participants.participants.filter(
              (p) => p.participantId !== participantId,
            );
        },
        undefined,
        "participants/remove",
      );
    },
    updateParticipantsStatus: (updatedParticipants: Participant[]) => {
      set(
        (state) => {
          const updatesMap = new Map(
            updatedParticipants.map((p) => [
              p.isRoomSystem ? p.entityId : p.participantId,
              p,
            ]),
          );

          state.participants.participants = state.participants.participants.map(
            (existing) => {
              const updated = updatesMap.get(
                existing.isRoomSystem
                  ? existing.entityId
                  : existing.participantId,
              );

              if (!updated) return existing;

              if (updated.isHandRaised) {
                return {
                  ...existing,
                  isAudioEnabled: updated.isAudioEnabled,
                  isVideoEnabled: updated.isVideoEnabled,
                  isHandRaised: true as const,
                  handRaisedAt: updated.handRaisedAt,
                };
              }

              return {
                ...existing,
                isAudioEnabled: updated.isAudioEnabled,
                isVideoEnabled: updated.isVideoEnabled,
                isHandRaised: false as const,
                handRaisedAt: undefined,
              };
            },
          );
        },
        undefined,
        "participants/updateParticipantsStatus",
      );
    },
    /**
     *
     */
    toggleCurrentParticipantHand: () => {
      set(
        (state) => {
          state.participants.participants = state.participants.participants.map(
            (p) => {
              if (p.isCurrentUser) {
                p.isHandRaised = !p.isHandRaised;
                p.handRaisedAt = p.isHandRaised ? new Date() : undefined;
              }
              return p;
            },
          );
        },
        undefined,
        "participants/toggleCurrentParticipantHand",
      );
    },
  },
});
